import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import Typography from '@material-ui/core/Typography'

import InputAdornment from '@material-ui/core/InputAdornment'
import Email from '@material-ui/icons/Email'

import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import SessionStyles from '../../styles/Session'

import Snackbar from '@material-ui/core/Snackbar'
import SnackbarWrapper from '../../containers/SnackbarWrapper'

import { handleForgotPassword } from '../../actions/authedUser'

//import * as API from '../../utils/api'

class ForgotPassword extends Component {
  state = {
    email: '',
    isEmailSent: false,
    snackbarOpen: false,
    snackMessage: ''
  }

  handleChangeEmail = (e) => {
    const email = e.target.value

    this.setState(() => ({
      email
    }))
  }

  handleForgot = e => {
    e.preventDefault()

    const { dispatch } = this.props
    const { email } = this.state

    dispatch(handleForgotPassword(email))
      .then((response) => {
        if (response.status === 0) {
          this.setState({ snackMessage: response.message })
          if (this.state.snackMessage !== '') {
            this.handleOpenSnackbar()
          }

        } else if (response.status === 1) {
          this.setState({isEmailSent: true})
          //console.log('e-mail has been sent')
        }
      })
  }

  handleOpenSnackbar = () => {
    this.setState({ snackbarOpen: true })
  }

  handleCloseSnackbar = () => {
    this.setState({ snackbarOpen: false })
  }

  render() {
    const { classes } = this.props
    const { email, snackMessage, isEmailSent } = this.state

    return (
      <div className={classNames(classes.session, classes.background)}>
        <div className={classes.content}>
          <div className={classes.wrapper}>
            <Card>
              <CardContent>
                <form onSubmit={this.handleForgot}>
                  <div className="text-xs-center pb-xs">
                    <img src="/static/images/logo.svg" alt=""/>
                    <Typography className={classes.accountInfo}>To reset your password, enter the email address you're using to sign in to your account.</Typography>
                  </div>

                  {!isEmailSent
                    ? <Fragment>
                        <TextField
                          id="email"
                          label="E-mail"
                          className={classes.textField}
                          fullWidth
                          margin="normal"
                          value={email}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <Email className={classes.icon} />
                              </InputAdornment>
                            ),
                          }}
                          onChange={this.handleChangeEmail}
                        />

                        <Button variant="raised" color="secondary" fullWidth type="submit" disabled={email === ''} className={classes.signinButton}>Reset password</Button>

                      </Fragment>
                    : <Typography className={classes.resultInfo}>To get back into your account, follow the instructions sent to your e-mail address.</Typography>}

                  <div className="pt-1 text-md-center">
                    <Link to="/" className={classes.linkButton}>
                      <Button>Sign in</Button>
                    </Link>
                    <Link to="/register">
                      <Button>Create new account</Button>
                    </Link>
                  </div>
                </form>
              </CardContent>

              <Snackbar
                open={this.state.snackbarOpen}
                autoHideDuration={6000}
                onClose={this.handleCloseSnackbar}
                className={classes.snackbar}
              >
                <SnackbarWrapper
                  onClose={this.handleCloseSnackbar}
                  variant="error"
                  message={snackMessage}
                />
              </Snackbar>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

ForgotPassword.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect()(withStyles(SessionStyles)(ForgotPassword))


// WEBPACK FOOTER //
// ./src/components/Authentication/ForgotPassword.js